import api from './client';

export interface StoreCharacterType {
  id: string;
  name: string;
  description: string | null;
  avatar_url: string;
  price: number;
  can_afford: boolean;
}

export interface StoreListResponse {
  character_types: StoreCharacterType[];
  player_coins: number;
}

export interface PurchasedCharacter {
  id: string;
  name: string;
  avatar_base: number;
  avatar_url: string | null;
  character_type_id: string | null;
  level: number;
  xp: number;
  pending_level_up: number | null;
  is_active: boolean;
  created_at: string;
}

export interface PurchaseResponse {
  success: boolean;
  remaining_coins?: number;
  character?: PurchasedCharacter;
  error?: string;
  message?: string;
}

export const getStoreCharacters = async (): Promise<StoreListResponse> => {
  const res = await api.get('/api/store/characters');
  return res.data;
};

export const purchaseCharacter = async (
  characterTypeId: string,
  characterName: string
): Promise<PurchaseResponse> => {
  const res = await api.post('/api/store/purchase', {
    character_type_id: characterTypeId,
    character_name: characterName,
  });
  return res.data;
};
